export enum DashboardDataTableColumnType {
  STATUS = 'status',
  TITLE = 'title',
  ACTION = 'action',
  SELECT = 'select',
}
